import script from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=137b4c2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137b4c2a"]])

export default __exports__